/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * Template API
 * Something something. <br><br>The spec is available at <a href='/swagger/api.json'>/swagger/api.json</a>.
 * OpenAPI spec version: 0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ApiAppError,
  CreateProductRequest,
  CreateProductResponse,
  GetProductResponse,
  GetProductsParams,
  GetProductsResponse,
  UpdateProductRequest,
  UpdateProductResponse
} from './schemas'
import { getApi } from '../client';
import type { ErrorType, BodyType } from '../client';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Create Product
 */
export const createProduct = (
    createProductRequest: BodyType<CreateProductRequest>,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<CreateProductResponse>(
      {url: `/product`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProductRequest, signal
    },
      options);
    }
  


export const getCreateProductMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<CreateProductRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<CreateProductRequest>}, TContext> => {
    
const mutationKey = ['createProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProduct>>, {data: BodyType<CreateProductRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createProduct(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProduct>>>
    export type CreateProductMutationBody = BodyType<CreateProductRequest>
    export type CreateProductMutationError = ErrorType<ApiAppError>

    /**
 * @summary Create Product
 */
export const useCreateProduct = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<CreateProductRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof createProduct>>,
        TError,
        {data: BodyType<CreateProductRequest>},
        TContext
      > => {

      const mutationOptions = getCreateProductMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete Product
 */
export const deleteProduct = (
    id: string,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<void>(
      {url: `/product/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteProductMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProduct>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProduct(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProduct>>>
    
    export type DeleteProductMutationError = ErrorType<ApiAppError>

    /**
 * @summary Delete Product
 */
export const useDeleteProduct = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteProduct>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Product
 */
export const getProduct = (
    id: string,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetProductResponse>(
      {url: `/product/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetProductQueryKey = (id: string,) => {
    return [`/product/${id}`] as const;
    }

    
export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ApiAppError>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = ErrorType<ApiAppError>


export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ApiAppError>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Product
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Product
 */
export const prefetchGetProduct = async <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProductQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * @summary Update Product
 */
export const updateProduct = (
    id: string,
    updateProductRequest: BodyType<UpdateProductRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateProductResponse>(
      {url: `/product/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateProductRequest
    },
      options);
    }
  


export const getUpdateProductMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: string;data: BodyType<UpdateProductRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: string;data: BodyType<UpdateProductRequest>}, TContext> => {
    
const mutationKey = ['updateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProduct>>, {id: string;data: BodyType<UpdateProductRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProduct(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateProduct>>>
    export type UpdateProductMutationBody = BodyType<UpdateProductRequest>
    export type UpdateProductMutationError = ErrorType<ApiAppError>

    /**
 * @summary Update Product
 */
export const useUpdateProduct = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: string;data: BodyType<UpdateProductRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateProduct>>,
        TError,
        {id: string;data: BodyType<UpdateProductRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateProductMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Products
 */
export const getProducts = (
    params?: GetProductsParams,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetProductsResponse>(
      {url: `/products`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetProductsQueryKey = (params?: GetProductsParams,) => {
    return [`/products`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductsQueryOptions = <TData = Awaited<ReturnType<typeof getProducts>>, TError = ErrorType<ApiAppError>>(params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) => getProducts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsQueryError = ErrorType<ApiAppError>


export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = ErrorType<ApiAppError>>(
 params: undefined |  GetProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = ErrorType<ApiAppError>>(
 params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = ErrorType<ApiAppError>>(
 params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Products
 */

export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = ErrorType<ApiAppError>>(
 params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Products
 */
export const prefetchGetProducts = async <TData = Awaited<ReturnType<typeof getProducts>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProductsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


